<template>
  <div>
    <!-- 整箱约号价格 -->
    <div v-show="isFcl" style="flex: 1;display: flex;flex-direction: column;">
      <div class="section">
        <div style="padding-top: 7px;padding-bottom: 7px;">
          <el-button type="primary" :disabled="!$checkPermission(['button_TabFclContractNoPrice_add'])" @click="addContractNo">{{ $t('CargoMsg.Cargo_AddContractNo') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-params.sync="fcl.up.girdParams"
          :grid-options="fcl.up.gridOptions"
          :column-defs="fcl.up.columnDefs"
          :row-data="fcl.up.rowData"
          :show-side-bar="false"
          @gridReady="params=>{fcl.up.gridApi=params.api}"
        />
      </div>
      <div class="section" style="flex: 1;">
        <div style="padding-top: 7px;padding-bottom: 7px;">
          <el-button type="primary" :disabled="!$checkPermission(['button_TabFclContractNoPrice_save'])" @click="addContractPrice">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-params.sync="fcl.down.girdParams"
          :grid-options="fcl.down.gridOptions"
          :column-defs="fcl.down.columnDefs"
          :row-data="fcl.down.rowData"
          style="width:100%"
          @gridReady="params=>{fcl.down.gridApi=params.api}"
        />
      </div>
    </div>

    <!-- 拼箱约号价格 -->
    <div v-show="!isFcl" style="flex: 1;display: flex;flex-direction: column;">
      <div class="section">
        <div style="padding-top: 7px;padding-bottom: 7px;">
          <el-button :disabled="!$checkPermission(['button_TabLclContractNoPrice_add'])" type="primary" @click="addContractNo">{{ $t('CargoMsg.Cargo_AddContractNo') }}</el-button>
        </div>
        <cargo-ag-grid
          config-module="101406"
          :grid-params.sync="lcl.up.girdParams"
          :grid-options="lcl.up.gridOptions"
          :column-defs="lcl.up.columnDefs"
          :row-data="lcl.up.rowData"
          @gridReady="params=>{lcl.up.gridApi=params.api}"
        />
      </div>
      <div class="section" style="flex: 1;">
        <div style="padding-top: 7px;padding-bottom: 7px;">
          <el-button type="primary" :disabled="!$checkPermission(['button_TabFclContractNoPrice_save'])" @click="addContractPrice">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-params.sync="lcl.down.girdParams"
          :grid-options="lcl.down.gridOptions"
          :column-defs="lcl.down.columnDefs"
          :row-data="lcl.down.rowData"
          style="width:100%"
          @gridReady="params=>{lcl.down.gridApi=params.api}"
        />
      </div>
    </div>

    <!-- 添加约号弹窗 -->
    <el-dialog
      v-if="dialog.visible"
      v-el-drag-dialog
      :visible.sync="dialog.visible"
      :title="$t('CargoMsg.Cargo_AddContractNo')"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeDialog"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')" required>
                <cargo-advance-select
                  :disabled="!dialog.isEdit"
                  filterable
                  :default-value="dialog.scno || undefined"
                  :cache="false"
                  tag-name="scno"
                  tag-value="scno"
                  :filter-tag-names="['scno']"
                  :static-options="dialog.scnoList"
                  @parentCallBack="onScNoChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.InnerContractNo')" required>
                <el-input v-model="dialog.contractNo" :disabled="!dialog.isEdit" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')" required>
                <el-date-picker v-model="dialog.beginDate" :disabled="!dialog.isEdit" :editable="false" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('CargoMsg.Cargo_InvalidDate')" required>
                <el-date-picker v-model="dialog.endDate" :disabled="!dialog.isEdit" :editable="false" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="margin-top: 10px; margin-bottom: 10px; font-size: 14px; font-weight: bold;">{{ $t('Partners.defaultMarkupRange') }}</div>
        <div style="margin-top: 10px; margin-bottom: 10px;">
          <el-button type="primary" :disabled="loadType ? !$checkPermission(['button_TabFclContractNoPrice_priceAdd']) : !$checkPermission(['button_TabLclContractNoPrice_priceAdd'])" @click="addDefaultPrice">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button type="danger" :disabled="loadType ? !$checkPermission(['button_TabFclContractNoPrice_priceDelete']) : !$checkPermission(['button_TabLclContractNoPrice_priceDelete'])" @click="deleteDefaultPrice">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
        <div class="section" style="flex: 1;">
          <cargo-ag-grid
            :grid-params.sync="dialog.girdParams"
            :grid-options="dialog.gridOptions"
            :column-defs="dialogColumnDefs"
            :row-data="dialog.rowData"
            :show-side-bar="false"
            style="width:100%"
            @gridReady="params=>{dialog.gridApi=params.api}"
          />
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="checkSaveContractNo">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="closeDialog">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { Company } from '@/class/model/mdm/Company'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import OperationRender from '@/components/OperationRender/index'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryPriceContractNo, saveContractNo, deleteContractNo, batchSaveContractPrice, getContractNoList, getContractNoPriceList, getContractNoDefaultPriceList } from '@/api/seaExport/contractNo'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'TabContractNoPrice',
  components: {
    CargoAdvanceSelect
  },
  props: {
    action: {
      type: String,
      required: true
    },
    loadType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: new Company().fillDefaultValue().getData(),
      portMap: new Map(),
      regionList: [],
      portList: [],
      dialog: {
        isEdit: false,
        visible: false,
        uuid: '',
        scno: '',
        contractNo: '',
        beginDate: '',
        endDate: '',
        scnoList: [],
        routeList: [],
        podList: [],
        girdParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressRowClickSelection: true,
          context: {
            componentParent: this
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        gridApi: null,
        deleteUuids: [], // 删除的UUID
        rowData: []
      },
      fcl: {
        up: {
          selectedRow: null, // 当前选中行
          girdParams: {},
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            context: {
              componentParent: this
            },
            onRowClicked: this.onRowClicked
          },
          columnDefs: [
            {
              headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
              colId: 'scNo',
              field: 'scNo',
              flex: 1
            }, {
              headerName: this.$t('SeaExport.InnerContractNo'),
              colId: 'contractNo',
              field: 'contractNo',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
              colId: 'beginDate',
              field: 'beginDate',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.dateLabelFunc(params.value)
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
              colId: 'endDate',
              field: 'endDate',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.dateLabelFunc(params.value)
              }
            }, {
              headerName: this.$t('SeaExport.Operation'),
              colId: 'operation',
              field: 'operation',
              flex: 1,
              cellStyle: { textAlign: 'center' },
              cellRendererFramework: OperationRender,
              cellRendererParams: {
                operations: [
                  {
                    title: this.$t('Payment.edit2'),
                    type: 'primary',
                    cssStyle: 'text-decoration: underline;',
                    onClick: (params) => {
                      this.editContractNo(params)
                    },
                    visible: (params) => params && params.uuid && this.$checkPermission(['button_TabFclContractNoPrice_edit'])
                  }, {
                    title: this.$t('FileHistory.Delete'),
                    type: 'primary',
                    cssStyle: 'text-decoration: underline;',
                    onClick: (params) => {
                      this.deleteContractNo(params)
                    },
                    visible: (params) => params && params.uuid && this.$checkPermission(['button_TabFclContractNoPrice_delete'])
                  }
                ]
              }
            }
          ],
          gridApi: null,
          rowData: []
        },
        down: {
          girdParams: {},
          gridOptions: {
            rowSelection: 'single',
            singleClickEdit: true,
            suppressCellSelection: true,
            context: {
              componentParent: this
            },
            frameworkComponents: { // 添加编辑组件
              CargoAgGridSelectEditor,
              CargoAgGridCommonInputEditor
            }
          },
          columnDefs: [
            {
              headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
              colId: 'scNo',
              field: 'scNo',
              flex: 1
            }, {
              headerName: this.$t('SeaExport.InnerContractNo'),
              colId: 'contractNo',
              field: 'contractNo',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
              colId: 'carrierId',
              field: 'carrierId',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
              colId: 'bookingAgent',
              field: 'bookingAgent',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
              colId: 'pol',
              field: 'pol',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
              colId: 'pod',
              field: 'pod',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_Airline'),
              colId: 'route',
              field: 'route',
              flex: 1,
              valueFormatter: (params) => {
                const curObj = params.data
                if (curObj && curObj['route']) {
                  const region = this.regionList.find(p => p.code === curObj['route'])
                  return region ? region.name : curObj['route']
                }
                if (curObj && curObj['pod'] && !curObj['route']) {
                  const port = this.portList.find(p => p.code === curObj['pod'])
                  if (port) {
                    const region = this.regionList.find(p => p.code === port.region)
                    return region ? region.name : ''
                  }
                }
                return ''
              },
              filterParams: {},
              filterValueGetter: (params) => {
                const curObj = params.data
                if (curObj && curObj['route']) {
                  const region = this.regionList.find(p => p.code === curObj['route'])
                  return region ? region.name : curObj['route']
                }
                if (curObj && curObj['pod'] && !curObj['route']) {
                  const port = this.portList.find(p => p.code === curObj['pod'])
                  if (port) {
                    const region = this.regionList.find(p => p.code === port.region)
                    return region ? region.name : ''
                  }
                }
                return ''
              }
            }, {
              headerName: this.$t('Partners.rateClass'),
              colId: 'priceTier',
              field: 'priceTier',
              valueFormatter: (params) => {
                return ColumnUtils.priceTierLabelFunc(params.value)
              },
              editable: true,
              cellEditor: 'CargoAgGridSelectEditor',
              cellEditorParams: {
                selectProps: {
                  filterable: true
                },
                options: SystemConstants.TIERS,
                tagName: 'label',
                tagValue: 'value'
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_Income20'),
              colId: 'income20',
              field: 'income20',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_Income40'),
              colId: 'income40',
              field: 'income40',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_Income40HC'),
              colId: 'incomeHc',
              field: 'incomeHc',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_Income45'),
              colId: 'income45',
              field: 'income45',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ],
          gridApi: null,
          rowData: []
        }
      },
      lcl: {
        up: {
          selectedRow: null, // 当前选中行
          girdParams: {},
          gridOptions: {
            rowSelection: 'single',
            suppressCellSelection: true,
            context: {
              componentParent: this
            },
            onRowClicked: this.onRowClicked
          },
          columnDefs: [
            {
              headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
              colId: 'scNo',
              field: 'scNo',
              flex: 1
            }, {
              headerName: this.$t('SeaExport.InnerContractNo'),
              colId: 'contractNo',
              field: 'contractNo',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
              colId: 'beginDate',
              field: 'beginDate',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.dateLabelFunc(params.value)
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
              colId: 'endDate',
              field: 'endDate',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.dateLabelFunc(params.value)
              }
            },
            {
              headerName: this.$t('common.createBy'),
              field: 'createdBy',
              colId: 'createdBy',
              flex: 1,
              cellRenderer: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
              },
              width: 150
            },
            {
              headerName: this.$t('common.dateCreated'),
              field: 'dateCreated',
              colId: 'dateCreated',
              flex: 1,
              cellRenderer: (params) => {
                return ColumnUtils.dateTimeLabelFunc(params.value)
              },
              width: 150
            }, {
              headerName: this.$t('baseInfo.partner.modifiedBy'),
              field: 'modifiedBy',
              colId: 'modifiedBy',
              flex: 1,
              cellRenderer: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
              },
              width: 150
            }, {
              headerName: this.$t('CargoMsg.Cargo_ModificationTime'),
              field: 'dateModified',
              colId: 'dateModified',
              flex: 1,
              cellRenderer: (params) => {
                return ColumnUtils.dateTimeLabelFunc(params.value)
              },
              width: 150
            }, {
              headerName: this.$t('SeaExport.Operation'),
              colId: 'operation',
              field: 'operation',
              flex: 1,
              cellStyle: { textAlign: 'center' },
              cellRendererFramework: OperationRender,
              cellRendererParams: {
                operations: [
                  {
                    title: this.$t('Payment.edit2'),
                    type: 'primary',
                    cssStyle: 'text-decoration: underline;',
                    onClick: (params) => {
                      this.editContractNo(params)
                    },
                    visible: (params) => params && params.uuid && this.$checkPermission(['button_TabLclContractNoPrice_edit'])
                  }, {
                    title: this.$t('FileHistory.Delete'),
                    type: 'primary',
                    cssStyle: 'text-decoration: underline;',
                    onClick: (params) => {
                      this.deleteContractNo(params)
                    },
                    visible: (params) => params && params.uuid && this.$checkPermission(['button_TabLclContractNoPrice_delete'])
                  }
                ]
              }
            }
          ],
          gridApi: null,
          rowData: []
        },
        down: {
          girdParams: {},
          gridOptions: {
            rowSelection: 'single',
            singleClickEdit: true,
            suppressCellSelection: true,
            context: {
              componentParent: this
            },
            frameworkComponents: { // 添加编辑组件
              CargoAgGridSelectEditor,
              CargoAgGridCommonInputEditor
            }
          },
          columnDefs: [
            {
              headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
              colId: 'scNo',
              field: 'scNo',
              flex: 1
            }, {
              headerName: this.$t('SeaExport.InnerContractNo'),
              colId: 'contractNo',
              field: 'contractNo',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
              colId: 'carrierId',
              field: 'carrierId',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
              colId: 'bookingAgent',
              field: 'bookingAgent',
              flex: 1,
              valueFormatter: (params) => {
                return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
              colId: 'pol',
              field: 'pol',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
              colId: 'pod',
              field: 'pod',
              flex: 1
            }, {
              headerName: this.$t('CargoMsg.Cargo_Airline'),
              colId: 'route',
              field: 'route',
              flex: 1,
              valueFormatter: (params) => {
                const curObj = params.data
                if (curObj && curObj['route']) {
                  const region = this.regionList.find(p => p.code === curObj['route'])
                  return region ? region.name : curObj['route']
                }
                if (curObj && curObj['pod'] && !curObj['route']) {
                  const port = this.portList.find(p => p.code === curObj['pod'])
                  if (port) {
                    const region = this.regionList.find(p => p.code === port.region)
                    return region ? region.name : ''
                  }
                }
                return ''
              }
            },
            {
              headerName: this.$t('Partners.rateClass'),
              colId: 'priceTier',
              field: 'priceTier',
              valueFormatter: (params) => {
                return ColumnUtils.priceTierLabelFunc(params.value)
              },
              editable: true,
              cellEditor: 'CargoAgGridSelectEditor',
              cellEditorParams: {
                selectProps: {
                  filterable: true
                },
                options: SystemConstants.TIERS,
                tagName: 'label',
                tagValue: 'value'
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_WeightPriceAdjust'),
              colId: 'income20',
              field: 'income20',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_CubagePriceAdjust'),
              colId: 'income40',
              field: 'income40',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }, {
              headerName: this.$t('CargoMsg.Cargo_MinimumPriceAdjust'),
              colId: 'incomeHc',
              field: 'incomeHc',
              valueFormatter: (params) => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: true,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              },
              flex: 1,
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ],
          gridApi: null,
          rowData: []
        }
      }
    }
  },
  computed: {
    isFcl() {
      return this.loadType === 'FCL'
    },
    dialogColumnDefs() {
      const result = [
        {
          headerName: '', checkboxSelection: true, width: 55,
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline'),
          colId: 'route',
          field: 'route',
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Region,
              clearable: true,
              filterable: true,
              staticOptions: this.dialog.routeList,
              tagName: 'name',
              tagValue: 'code'
            }
          },
          valueFormatter: (params) => {
            if (params.value) {
              const region = this.regionList.find(p => p.code === params.value)
              return region ? region.name : ''
            }
            return ''
          },
          onCellValueChanged: p => this.onChargeCellChange(p),
          flex: 1
        }
      ]
      if (this.isFcl) {
        result.push({
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'pol',
          field: 'pol',
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: params => {
            return {
              selectProps: {
                clearable: true,
                filterable: true,
                filterTagNames: ['code'],
                staticOptions: this.getPodFilter(params),
                tagName: 'code',
                tagValue: 'code'
              }
            }
          },
          flex: 1
        })
      }
      result.push({
        headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
        colId: 'pod',
        field: 'pod',
        editable: true,
        cellEditor: 'CargoAgGridAdvanceSelectEditor',
        cellEditorParams: params => {
          return {
            selectProps: {
              clearable: true,
              filterable: true,
              filterTagNames: ['code'],
              staticOptions: this.portList,
              tagName: 'code',
              tagValue: 'code'
            }
          }
        },
        onCellValueChanged: p => this.onChargeCellChange(p),
        flex: 1
      }, {
        headerName: this.$t('Partners.rateClass'),
        colId: 'priceTier',
        field: 'priceTier',
        valueFormatter: (params) => {
          return ColumnUtils.priceTierLabelFunc(params.value)
        },
        editable: true,
        cellEditor: 'CargoAgGridSelectEditor',
        cellEditorParams: {
          selectProps: {
            filterable: true
          },
          options: SystemConstants.TIERS,
          tagName: 'label',
          tagValue: 'value'
        },
        flex: 1
      }, {
        headerName: this.isFcl ? this.$t('CargoMsg.Cargo_Income20') : this.$t('CargoMsg.Cargo_WeightPriceAdjust'),
        colId: 'income20',
        field: 'income20',
        valueFormatter: (params) => {
          return this.$numeral(params.value).format('0.00')
        },
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        flex: 1
      }, {
        headerName: this.isFcl ? this.$t('CargoMsg.Cargo_Income40') : this.$t('CargoMsg.Cargo_CubagePriceAdjust'),
        colId: 'income40',
        field: 'income40',
        valueFormatter: (params) => {
          return this.$numeral(params.value).format('0.00')
        },
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        flex: 1
      }, {
        headerName: this.isFcl ? this.$t('CargoMsg.Cargo_Income40HC') : this.$t('CargoMsg.Cargo_MinimumPriceAdjust'),
        colId: 'incomeHc',
        field: 'incomeHc',
        valueFormatter: (params) => {
          return this.$numeral(params.value).format('0.00')
        },
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        flex: 1
      }, {
        headerName: this.$t('CargoMsg.Cargo_Income45'),
        colId: 'income45',
        field: 'income45',
        hide: !this.isFcl,
        valueFormatter: (params) => {
          return this.$numeral(params.value).format('0.00')
        },
        editable: true,
        cellEditor: 'CargoAgGridCommonInputEditor',
        cellEditorParams: {
          isNumber: true,
          inputProps: {
            controls: false,
            precision: 2
          }
        },
        flex: 1
      })
      return result
    }
  },
  async created() {
    await this.initBasicData()
    // 转换成map 键值分别是 航线代码-》港口
    if (this.portList && this.portList.length > 0) {
      for (const port of this.portList) {
        const region = port.region
        if (!region) continue
        let ports = null
        if (this.portMap.has(region)) {
          ports = this.portMap.get(region)
        }
        if (!ports) ports = []
        ports.push(port)
        this.portMap.set(region, ports)
      }
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.form = row
      const loading = getLoading4Cxt(this)
      try {
        await this.loadData()
      } finally {
        loading.close()
      }
    },
    // 批量保存运价
    addContractPrice() {
      const result = this.isFcl ? this.fcl.down.rowData : this.lcl.down.rowData
      if (!result || result.length <= 0) {
        this.$message.warning(this.$t('Information.DataIsIncorrectPleaseCheck'))
        return
      }
      const updates = result.filter(p => !p.update)
      if (updates && updates.length > 0) {
        this.loading = getLoading()
        const item = {}
        item.uuid = this.isFcl ? this.fcl.up.selectedRow.uuid : this.lcl.up.selectedRow.uuid
        item.contractNoPrice = updates
        batchSaveContractPrice(item).then(res => {
          this.$message.success(this.$t('Partners.batchSaveSucceeded'))
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    async loadData() {
      if (!this.form.uuid) return
      const result = await getContractNoList({ companyUuid: this.form.uuid, loadType: this.loadType })
      const rows = result.data || []
      if (this.isFcl) {
        if (this.fcl.up.gridApi) {
          await sleep(100)
        } else {
          await ensureExecuteSuccess(() => this.fcl.up.gridApi)
        }
        this.fcl.up.rowData = rows
        this.fcl.up.gridApi.clearFocusedCell()
        this.fcl.up.gridApi.refreshCells({ force: true })
        this.fcl.down.rowData = []
        console.log('this.fcl.up.rowData=============', rows)
      } else {
        if (this.lcl.up.gridApi) {
          await sleep(100)
        } else {
          await ensureExecuteSuccess(() => this.lcl.up.gridApi)
        }
        this.lcl.up.rowData = rows
        this.lcl.up.gridApi.refreshCells({ force: true })
        this.lcl.up.gridApi.clearFocusedCell()
        this.lcl.down.rowData = []
        console.log('this.lcl.up.rowData=============', rows)
      }
    },
    // 明细列编辑，编辑过的update=true
    onCellChange(params) {
      const price = params.data
      if (price.uuid) price.updated = true // 更新标识
    },
    // 删除客户约号
    deleteContractNo(params) {
      if (!params || !params.uuid || !params.scNo || !params.contractNo) {
        this.$message.warning('请选择你要删除的约号！')
        return
      }
      const item = {
        conMap: {
          uuid: params.uuid,
          scNo: params.scNo,
          contractNo: params.contractNo
        }
      }
      this.loading = getLoading()
      deleteContractNo(item).then(res => {
        const result = res.data
        if (result.jobList) {
          this.$message.warning(this.$t('Partners.priceAdjustmentRecordUsedAndCannotDeleted'))
          return
        }
        if (result.count && result.count > 0) {
          this.$message.success(this.$t('Partners.deleteSucceeded'))
          this.loadData()
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    checkModel() {
    },
    // 保存
    save() {
    },
    // 行点击
    async onRowClicked(event) {
      if (!event || !event.data) return
      const selectedRow = event.data
      if (this.isFcl) {
        this.fcl.up.selectedRow = selectedRow
        const temp = await getContractNoPriceList({ companyContractNoUuid: selectedRow.uuid })
        this.fcl.down.rowData = temp.data || []
      } else {
        this.lcl.up.selectedRow = selectedRow
        const temp = await getContractNoPriceList({ companyContractNoUuid: selectedRow.uuid })
        this.lcl.down.rowData = temp.data || []
      }
    },

    // 默认调价 ==============================================================
    // 编辑约号
    async editContractNo(params) {
      if (!params || !params.uuid || !params.scNo || !params.contractNo) {
        this.$message.warning(this.$t('Partners.selectAppointmentNumberToEdit'))
        return
      }
      await this.queryPriceContractNo()
      const temp = await getContractNoDefaultPriceList({ companyContractNoUuid: params.uuid })
      this.dialog.rowData = temp.data || []
      this.dialog.routeList = [...this.regionList] // 航线
      this.dialog.podList = [...this.portList] // 目的港
      this.dialog.uuid = params.uuid
      this.dialog.scno = params.scNo
      this.dialog.contractNo = params.contractNo
      this.dialog.beginDate = params.beginDate
      this.dialog.endDate = params.endDate
      this.dialog.isEdit = false
      this.dialog.visible = true
    },
    // 点击添加约号
    async addContractNo() {
      await this.queryPriceContractNo()
      this.dialog.routeList = [...this.regionList]
      this.dialog.podList = [...this.portList]
      this.dialog.isEdit = true
      this.dialog.visible = true
    },
    // 查询运价的船司约号
    async queryPriceContractNo() {
      this.loading = getLoading()
      const conMap = { loadType: this.loadType }
      this.dialog.scnoList = await queryPriceContractNo({ conMap }).then((res) => (res.data || [])).finally(() => {
        this.loading.close()
      })
    },
    // 校验
    checkSaveContractNo() {
      if (!this.dialog.scno) {
        this.$message.warning(this.$t('Partners.shipSecretaryAppointmentNumberCannotEmpty'))
        return
      }
      if (!this.dialog.contractNo) {
        this.dialog.contractNo = this.dialog.scno
      }
      if (!this.dialog.beginDate) {
        this.$message.warning(this.$t('Partners.effectiveDateCannotBlank'))
        return
      }
      if (!this.dialog.endDate) {
        this.$message.warning(this.$t('Partners.expirationDateCannotBlank'))
        return
      }
      if (new Date(this.dialog.beginDate).getTime() > new Date(this.dialog.endDate).getTime()) {
        this.$message.warning(this.$t('Partners.expirationDateMustGreaterEqualEffectiveDate'))
        return
      }
      if (!this.dialog.rowData || this.dialog.rowData.length <= 0) {
        this.$message.warning(this.$t('Partners.defaultPriceIncreaseRangeCannotBlank'))
        return
      }
      let count = 0
      const routeMap = new Map()
      const routePodMap = new Map()
      for (const defaultPrice of this.dialog.rowData) {
        // 有目的港就一定要有航线
        if (!defaultPrice.route && defaultPrice.pod) {
          this.$message.warning(this.$t('Partners.selectRouteCorrespondingToDestinationPort'))
          return
        }
        if (!defaultPrice.route && !defaultPrice.pod) {
          count++
        }
        if (count > 1) {
          this.$message.warning(this.$t('Partners.oneRecordWithoutRouteAndDestination'))
          return
        }
        // 这里只验证航线有值，目的港没值的情况
        if (defaultPrice.route && !defaultPrice.pod && routeMap.has(defaultPrice.route)) {
          const region = this.regionList.find(p => p.code === defaultPrice.route)
          const name = region ? region.name : defaultPrice.route
          this.$message.warning(this.$t('Partners.sameRoute') + '【' + name + '】' + this.$t('Partners.oneRecordCanGeneratedPleaseModify'))
          return
        }
        if (defaultPrice.route && !defaultPrice.pod) {
          routeMap.set(defaultPrice.route, defaultPrice.route)
        }
        // 这里验证航线有值，目的港有值的情况
        const routePod = defaultPrice.route + '-' + defaultPrice.pod
        if (defaultPrice.route && defaultPrice.pod && routePodMap.has(routePod)) {
          const region = this.regionList.find(p => p.code === defaultPrice.route)
          const name = region ? region.name : defaultPrice.route
          this.$message.warning(this.$t('Partners.sameRouteAndDestination') + '【' + name + '-' + defaultPrice.pod + '】' + this.$t('Partners.oneRecordCanGeneratedPleaseModify'))
          return
        }
        if (defaultPrice.route && defaultPrice.pod) {
          routePodMap.set(routePod, routePod)
        }
      }
      this.saveContractNo()
    },
    // 保存约号及默认加价幅度
    saveContractNo() {
      const contract = {}
      contract.uuid = this.dialog.uuid
      contract.scno = this.dialog.scno
      contract.contractNo = this.dialog.contractNo
      contract.companyUuid = this.form.uuid
      contract.loadType = this.loadType
      contract.beginDate = this.dialog.beginDate
      contract.endDate = this.dialog.endDate
      contract.priceTier = 1
      contract.income20 = 0
      contract.income40 = 0
      contract.incomeHc = 0
      contract.income45 = 0
      // 默认加价幅度
      contract.contractNoDefaultPrices = this.dialog.rowData
      contract.deleteUuids = this.dialog.deleteUuids || [] // 要删除的加价幅度
      this.loading = getLoading()
      saveContractNo(contract).then(res => {
        this.$message.success(this.$t('Message.SaveSucceed'))
        this.loadData()
        this.closeDialog()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 关闭弹框
    closeDialog() {
      this.dialog.uuid = ''
      this.dialog.scno = ''
      this.dialog.contractNo = ''
      this.dialog.beginDate = ''
      this.dialog.endDate = ''
      this.dialog.rowData = []
      this.dialog.scnoList = []
      this.dialog.routeList = []
      this.dialog.podList = []
      this.dialog.deleteUuids = []
      this.dialog.isEdit = false
      this.dialog.visible = false
    },
    // 弹框中船司约号改变
    onScNoChange(event) {
      this.dialog.scno = event.value
      // const item = {}
      // item.priceTier = 1
      // item.income20 = 0
      // item.income40 = 0
      // item.incomeHc = 0
      // item.income45 = 0
      // this.dialog.rowData = [item]
    },
    // 调价列编辑
    onChargeCellChange(params) {
      const curEntity = params.data
      switch (params.colDef.field) {
        case 'route': {
          // 更新航线需要控制目的港的数据源
          if (curEntity.route) {
            this.dialog.podList = this.portMap.get(curEntity.route)
          } else {
            this.dialog.podList = this.portList
          }
          // 若当前目的港有值，则需要判断是否是这条航线的目的港，不是则需要清空
          if (curEntity.pod) {
            const port = this.dialog.podList.find(p => p.code === curEntity.pod)
            if (!port) {
              curEntity.pod = ''
            }
          }
          break
        }
        case 'pod': {
          // 选择目的港则需要带出对应的航线
          if (curEntity.pod) {
            const port = this.dialog.podList.find(p => p.code === curEntity.pod)
            if (port) {
              const region = this.regionList.find(p => p.code === port.region)
              curEntity.route = region ? region.code : ''
            }
          }
          break
        }
        default: {
          break
        }
      }
      this.dialog.gridApi.refreshCells({ force: true })
    },
    // 新增调价
    addDefaultPrice() {
      const item = {}
      item.route = ''
      item.pol = ''
      item.pod = ''
      item.priceTier = 1
      item.income20 = 0
      item.income40 = 0
      item.incomeHc = 0
      item.income45 = 0
      if (!this.dialog.rowData) this.dialog.rowData = []
      this.dialog.rowData.push(item)
    },
    // 删除调价-批量
    deleteDefaultPrice() {
      const selectRows = this.dialog.gridApi.getSelectedRows()
      const rows = this.dialog.rowData
      for (const cur of selectRows) {
        const index = rows.indexOf(cur)
        if (index > -1) {
          rows.splice(index, 1)
        }
        if (cur.uuid) {
          this.dialog.deleteUuids.push(cur.uuid)
        }
      }
    },
    async initBasicData() {
      if (!this.portList || this.portList.length <= 0) {
        this.portList = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      }
      if (!this.regionList || this.regionList.length <= 0) {
        this.regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
      }
    },
    getPodFilter(params) {
      if (!params.data || !params.data['route']) {
        return this.portList
      }
      return this.dialog.podList
    }
  }
}
</script>
<style scoped lang="scss">
</style>
